<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">任务管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="">
                <el-button size="small" type="primary" @click="addTask">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table size="small" :data="listData" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column show-overflow-tooltip prop="mode" label="任务类型" >
                <template slot-scope="scope">
                    <div v-if="scope.row.mode == 1">首次任务</div>
                    <div v-if="scope.row.mode == 2">每日任务</div>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="name" label="任务标题" >
                <template slot-scope="scope">
                    <div v-if="scope.row.type == 4">{{scope.row.name}}(对局数{{ scope.row.palyTimes }})</div>
                    <div v-if="scope.row.type != 4">{{ scope.row.name }}</div>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="integral" label="积分" ></el-table-column>
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                <el-button size="mini" type="text" @click="handleEdit(scope.row)">编辑</el-button>
                <el-button size="mini" type="text" v-if="scope.$index != 0" @click="sortClick(scope.row , scope.$index , 'top')">上移</el-button>
                <el-button size="mini" type="text" v-if="scope.$index != (listData.length-1)" @click="sortClick(scope.row , scope.$index , 'bottom')">下移</el-button>
                <el-button size="mini" type="text" @click="deleteTask(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
        <!-- 新增 -->
        <el-dialog :visible.sync="editFormVisible" width="30%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="推广员名称">
                <el-input size="small" v-model="editForm.name" style="width:230px" auto-complete="off" placeholder="请输入部门名称"></el-input>
                </el-form-item>
                <el-form-item label="手机号" >
                <el-input size="small" v-model="editForm.phone" style="width:230px" auto-complete="off" placeholder="请输入部门代码"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
        <!-- 创建任务 -->
        <el-dialog title="创建任务" :visible.sync="addTaskFlag" width="25%" @click="closeDialog">
                <el-form :model="addTaskForm" ref="addTaskForm" label-width="120px" :rules="rules" class="user-search">
                    <el-form-item label="选择任务类型">
                        <el-radio v-model="addTaskForm.mode" @input="radioClick" :label="1">首次任务</el-radio>
                        <el-radio v-model="addTaskForm.mode" @input="radioClick" :label="2">每日任务</el-radio>
                    </el-form-item>
                    <el-form-item label="选择具体任务" prop="taskType">
                        <el-select v-model="addTaskForm.taskType" @change="selectChange" placeholder="请选择">
                            <el-option
                            v-for="(item , index) in options"
                            :key="item.value"
                            :label="item.name"
                            :value="index">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="游戏对局次数" v-if="palyTimesFlag == true" prop="palyTimes">
                        <el-input size="small" style="width:220px" v-model="addTaskForm.palyTimes"></el-input>
                    </el-form-item>
                    <el-form-item label="赠送积分" prop="integral">
                        <el-input size="small" style="width:220px" v-model="addTaskForm.integral "></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="addTaskFlag = false">取消</el-button>
                    <el-button size="small" type="primary" :loading="loading" :disabled="submitFlag" v-preventReClick class="title" @click="addTaskSubmit('addTaskForm')">保存</el-button>
                </div>
        </el-dialog>
</div>
</template>
<script>
import Pagination from '../../../components/Pagination'
import { loadPayOrderList , loadCustomerList , 
    loadPayChannelList , getDivisionOrder ,
    exportExcel , getTaskListForNew ,
    loadTaskList , saveOrUpdateTask,
    changeTaskSort ,deleteTask} from '../../../api/userMG'
export default {
    data(){
        return{
            addTaskForm:{
                mode:1
            },
            palyTimesFlag:false,
            addTaskFlag:false,
            bindingFlag:false,
            activeName:"information",
            detailsFlag:false,
            options: [{
                value: '选项1',
                label: '黄金糕'
                }, {
                value: '选项2',
                label: '双皮奶'
                }, {
                value: '选项3',
                label: '蚵仔煎'
                }, {
                value: '选项4',
                label: '龙须面'
                }, {
                value: '选项5',
                label: '北京烤鸭'
            }],
            editForm:{},
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                name: '',
                payChannel:'',
                time:[],
                taskType:''
            },
            machineData:[],
            listData: [{
                url:'https://thirdwx.qlogo.cn/mmopen/vi_32/8kKUTuTsoibsLSHPAXfUAjX7zPssdyWk8CorQicic8gzHHuu517RcdXEhKFtIqvNyR0APLeyPiaqn6iaGfWzJp4Er5Q/132',
                sort:'1',
                status:0,
            }], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            channelsList:[],
            divisionOrder:{},
            rules: {
                integral: [
                { required: true, message: '请输入积分', trigger: 'blur' },
                { message: '格式错误', trigger: 'blur' , pattern:/^[0-9]*$/ }
                ],
                palyTimes: [
                { required: true, message: '请输入对局数', trigger: 'blur' },
                { message: '格式错误', trigger: 'blur' , pattern:/^[0-9]*$/ }
                ],
                taskType: [
                { required: true, message: '请选择具体任务', trigger: 'blur' }
                ],
                userSex: [{ required: true, message: '请选择性别', trigger: 'blur' }]
            },
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
        // this.loadPayChannelList()
    },
    methods:{
        deleteTask(id){
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteTask({id:id}).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.getdata()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        addTaskSubmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    saveOrUpdateTask({
                        mode:this.addTaskForm.mode,
                        type:this.options[this.addTaskForm.taskType].type,
                        name:this.options[this.addTaskForm.taskType].name,
                        palyTimes:this.addTaskForm.palyTimes,
                        integral:this.addTaskForm.integral,
                        id:this.addTaskForm.id == undefined?'':this.addTaskForm.id
                    }).then(res=>{
                        if(res.success){
                            this.$message.success('创建成功')
                            this.addTaskForm = {
                                mode:1,
                                type:'',
                                integral:'',
                                palyTimes:'',
                            }
                            this.addTaskFlag = false
                            this.getdata()
                        }else {
                            this.$message.error(res.messages)
                        }
                    })
                } else {
                    return false
                }
            })
        },
        sortClick(row , index , type){
            let associationId = ''
            if(type == 'top'){
                associationId = this.listData[index - 1].id
            }else if(type == 'bottom') {
                associationId = this.listData[index + 1].id
            }
            changeTaskSort({
                id:row.id,
                associationId:associationId
            }).then(res=>{
                if(res.success){
                    this.$message.success('操作成功')
                    this.listData = res.tasks
                }
            })
        },
        selectChange(event){
            console.log(event)
            if(this.options[event].type == 4){
                this.palyTimesFlag = true
            }else {
                this.palyTimesFlag = false
            }
        },
        addTask(){
            this.addTaskFlag = true
            this.palyTimesFlag = false
            this.addTaskForm = {
                mode:1,
                type:'',
                integral:'',
                palyTimes:'',
                taskType:''
            }
            this.getTaskListForNew()
        },
        radioClick(){
            this.getTaskListForNew()
        },
        getTaskListForNew(){
            getTaskListForNew({
                mode:this.addTaskForm.mode
            }).then(res=>{
                this.addTaskForm.taskType = ''
                this.palyTimesFlag = false
                this.options = res.taskModels
            })
        },
        handleEdit(row){
            getTaskListForNew({
                mode:row.mode,
                id:row.id
            }).then(res=>{
                this.options = res.taskModels
                for(let item in res.taskModels){
                    console.log(item)
                    if(res.taskModels[item].type == row.type){
                        row.taskType = Number(item)
                    }
                    if(res.taskModels[item].type == 4){
                        this.palyTimesFlag = true
                    }else {
                        this.palyTimesFlag = false
                    }
                }
                this.addTaskForm = JSON.parse(JSON.stringify(row))
                this.addTaskFlag = true
            })
        },
        addClick(){
            this.editFormVisible = true
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        empty(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.formInline.name = '' 
            this.formInline.phone = ''
            this.formInline.payChannel = ''
            this.formInline.time = []
            this.getdata()
        },
        search(){
            console.log(this.formInline)
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        loadPayChannelList(){
            loadPayChannelList({
                
            }).then(res=>{
                this.channelsList = res.channels
            })
        },
        getdata(){
            loadTaskList({
            }).then(res=>{
                this.listData = res.tasks
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/shoppingMall/activity/taskManagemen.vue